import type { PaymentGateway } from '@/generated/graphql';

import { IUser, mapGQLUser } from './user';

export interface IPaymentGateway {
  id: string;
  name: string;
  accountNumber: string;
  isDisabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IPaymentGatewayTable {
  id: string;
  name: string;
  accountNumber: string;
  isDisabled: boolean;
  createdAt: string;
}

export interface IPaymentGatewayQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLPaymentGateway(gql_PaymentGateway?: PaymentGateway | null): IPaymentGateway {
  return {
    id: gql_PaymentGateway?.id ?? '',
    name: gql_PaymentGateway ? gql_PaymentGateway.name ?? '' : '',
    accountNumber: gql_PaymentGateway ? gql_PaymentGateway.accountNumber ?? '' : '',
    isDisabled: gql_PaymentGateway ? gql_PaymentGateway.isDisabled ?? false : false,
    updatedAt: gql_PaymentGateway ? gql_PaymentGateway.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    createdAt: gql_PaymentGateway
      ? new Date(gql_PaymentGateway.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}

export interface IAddPaymentGatewayInput {
  name: string;
  accountNumber: string;
}
